<div class="carousel" [style.width.px]="cellWidth">
    <div #element *ngFor="let i of [0, 2, 4, 12, 14]; let index = index" class="item">
      <span class="data-index">{{index}}</span>
      <img (load)="index == 0 && getDimensions(element)" [src]="images[index]"/> 
    </div>
    <div class="controls">
        <button class="btn-prev" (click)="prev()">
            <img src="./assets/img/gennius/left-arrow.svg" alt="gennius">
        </button>
        <button class="btn-next" (click)="next()">
            <img src="./assets/img/gennius/right-arrow.svg" alt="gennius"> 
        </button>
    </div>

    <img class="img-seed"  src="./assets/img/gennius/logo-seed-group.webp" alt="gennius">
</div>

